'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _immutable = require('immutable');

var _paths = require('./paths');

var _getEventsForStage = require('./getEventsForStage');

var _getEventsForStage2 = _interopRequireDefault(_getEventsForStage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id) {
  return function (dispatch, getState) {
    var cachedStages = (0, _paths.getStages)(getState(), feis_id);

    // prefer the cached version
    if (cachedStages && cachedStages.every(function (id) {
      return (0, _paths.getEventsOnStage)(getState(), id);
    })) return;

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id)
      },
      types: ['GET_STAGES_START', 'GET_STAGES', 'GET_STAGES_ERROR']
    })).then(function () {
      return (0, _paths.getStages)(getState(), feis_id).forEach(function (id) {
        return dispatch((0, _getEventsForStage2.default)(feis_id, id));
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/getStages.js
// module id = 244
// module chunks = 0